export default __webpack_public_path__ + "static/media/alphabet-yellow-h.5756852a.png";